export const columns = [
  {
    title: 'Id',
    name: 'id'
  },
  {
    title: 'Nombre',
    name: 'name'
  },
  {
    title: 'Descripción',
    name: 'description'
  }
];

export const mapData = data =>
  data.map(datum => {
    return {
      ...datum,
      name: datum.action
    };
  });
